import { render } from "./IconPage.vue?vue&type=template&id=dfa77826&scoped=true"
const script = {}

import "./IconPage.vue?vue&type=style&index=0&id=dfa77826&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa77826"]])

export default __exports__